import React, {Component} from 'react';
import PulsoidClient from '../../PulsoidClient';
import Card from 'react-bootstrap/Card';
import {CardGroup, Col, Row} from 'react-bootstrap';
import {MarketPlace} from './Marketplace';
import {resolveWidget} from './utils';
import Websocket from 'react-websocket';
import {ActionLink, Secondary} from '../../system/buttons';
import {MenuItemContainer} from '../../system/menu';
import {groupByThree} from '../../system/utils';
import {LoaderWrapper} from '../../system/Loader/Loader';
import {DASHBOARD_ROUTES} from '../navigation/dashboard/DashboardRoutes';
import {buildRoute} from '../navigation/navigationUtils';
import {WidgetPreviewContainer} from '../../system/WidgetPreviewContainer/WidgetPreviewContainer';

export const shouldScrollToMarketplace = (history) =>
  !!(
    history.location.hash.includes('marketplace') ||
    history.location.search.includes('tag')
  );
export const scrollToMarketplace = () =>
  document.getElementById('marketplace').scrollIntoView();

export default class Configuration extends Component {
  client = new PulsoidClient();
  state = {
    widgets: undefined,
    wsListen:
      'wss://ramiel.pulsoid.net/listen/7f20184a-5fcf-11e6-8b77-86f30ca893d3',
    heartRate: 80,
  };

  componentDidMount() {
    this.initWidgets();
    this.initUser();
  }

  initUser = () =>
    this.client.getUserInfo().then((user) => this.setState({user}));

  initWidgets = async () => {
    await this.client
      .getAllWidgets()
      .then((widgets) => this.setState({widgets}));
    if (shouldScrollToMarketplace(this.props.history)) {
      await this.client
        .getPredefinedWidgets()
        .then((predefinedWidgets) =>
          this.setState({predefinedWidgets}, scrollToMarketplace)
        );
    } else {
      await this.client
        .getPredefinedWidgets()
        .then((predefinedWidgets) => this.setState({predefinedWidgets}));
    }
  };

  handleData = (pulse) => {
    let data = JSON.parse(pulse).data;
    this.setState({heartRate: data.heartRate});
  };

  deleteWidget = async (widgetId) => {
    if (
      window.confirm(
        'Are you sure you want to delete widget configuration?'
      ) === true
    ) {
      await this.client.deleteWidget(widgetId);
      await this.initWidgets();
    }
  };

  handleAddNewWidget = async (predefinedWidgetId, name) => {
    const newWidget = await this.client.addWidget(predefinedWidgetId, name);

    if (newWidget) {
      const newPath = buildRoute({
        path: DASHBOARD_ROUTES.CONFIGURATION_EDIT_WIDGET,
        params: {id: newWidget.id},
      });
      this.props.history.push(newPath);
    }
  };

  render() {
    return (
      <MenuItemContainer title={'Widgets'}>
        {this.state.wsListen && (
          <Websocket
            reconnectIntervalInMilliSeconds={3000}
            url={this.state.wsListen}
            onMessage={this.handleData}
          />
        )}

        <h2 style={{paddingLeft: '10px'}}> My widgets</h2>
        <hr />

        <Col style={{width: '900px'}}>
          <LoaderWrapper
            description={'Loading widgets...'}
            loading={!!!this.state.widgets}
          >
            <WidgetsCard
              widgets={this.state.widgets}
              deleteWidget={this.deleteWidget}
            />
          </LoaderWrapper>
        </Col>

        <h3 style={{paddingLeft: '10px'}} id="marketplace">
          {' '}
          Library
        </h3>
        <hr />
        <Col style={{width: '900px'}}>
          <LoaderWrapper
            description={'Loading marketplace...'}
            loading={!!!this.state.predefinedWidgets}
          >
            <MarketPlace
              predefinedWidgets={this.state.predefinedWidgets}
              history={this.props.history}
              heartRate={this.state.heartRate}
              addNewWidget={this.handleAddNewWidget}
            />
          </LoaderWrapper>
        </Col>
      </MenuItemContainer>
    );
  }
}

const WidgetsCard = ({widgets, deleteWidget}) => {
  return groupByThree(
    widgets.map((e) => {
      return (
        <WidgetPreviewContainer
          key={e.id}
          id={e.metaId}
          title={e?.note?.name}
          subtitle={e?.note?.description}
          actions={
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                padding: '0 8px',
              }}
            >
              <ActionLink
                style={{width: 100, whiteSpace: 'nowrap'}}
                to={buildRoute({
                  path: DASHBOARD_ROUTES.CONFIGURATION_EDIT_WIDGET,
                  params: {id: e.id},
                })}
              >
                Configure
              </ActionLink>
              <Secondary
                style={{width: 100}}
                onClick={() => {
                  deleteWidget(e.id);
                }}
                variant="dark"
              >
                Delete
              </Secondary>
            </div>
          }
        >
          {e.configuration &&
            resolveWidget(e.configuration, e.metaId, e.id, 80)}
        </WidgetPreviewContainer>
      );
    }),
    (index) => <EmptyCard key={index} />
  ).map((value, index) => <CardGroup key={index}>{value}</CardGroup>);
};

const EmptyCard = () => (
  <Card
    style={{
      width: '18rem',
      height: '10rem',
      margin: '5px',
      border: '1px solid white',
    }}
  />
);
